import { render } from "./UserTransactions.vue?vue&type=template&id=e591b9e8&scoped=true"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"

import "./UserTransactions.vue?vue&type=style&index=0&id=e591b9e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e591b9e8"]])

export default __exports__